import React from 'react'
import './Css/Footer.css'
import { Container, Row, Col } from 'react-bootstrap'
import { AiFillFacebook, AiFillInstagram, AiFillLinkedin, AiFillTwitterCircle, AiFillYoutube, AiOutlineHeart } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import { HiOutlineLocationMarker, HiOutlineMail, HiOutlinePhone, HiOutlineClock} from "react-icons/hi";
import CategoryPage from '../Pages/CategoryPage'
import { HiArrowLongRight } from 'react-icons/hi2'

const API_BASE =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL
    : "http://localhost:5000";

const Footer = ({home, categoryPage}) => {
    const directoryCategory = [{
        categoryName: "Pet Grooming",
        categorySlug: "pet-grooming"
    }, {
        categoryName: "Pet Boarding",
        categorySlug: "pet-boarding"
    }, {
        categoryName: "Pet Shops Chennai",
        categorySlug: "pet-shops"
    }, {
        categoryName: "Pet Shops South India",
        categorySlug: "pet-shops-south-india"
    }, {
        categoryName: "Pet Grooming South India",
        categorySlug: "pet-grooming-south-india"
    }, {
        categoryName: "Pet Boarding Chennai",
        categorySlug: "pet-boarding-chennai"
    }, {
        categoryName: "Golden Retriever Puppies for Sale",
        categorySlug: "golden-retriever-puppies-for-sale"
    }, {
        categoryName: "Chihuahua Puppies for Sale",
        categorySlug: "chihuahua-puppies-for-sale"
    }]
    const displayedCategories = directoryCategory.slice(0, 5);
  return (
    <div className='footer'>
        <footer className="bg-gray-900 text-white ">
            <Container>
                <div className="top-footer d-flex justify-content-between align-items-center mb-3">
                    <Row>
                        <Col>
                            <div className="footer-logo d-flex align-items-center">
                                {/* <span className='icon d-flex align-items-center justify-content-center'>
                                    <AiOutlineHeart size={28} style={{ color: '#fff',  padding: '4px' }} />
                                </span>
                                <b>PetPals</b><span className='highlight'><b>India</b></span>
                                 */}
                                 <img src={`${API_BASE}/${home.siteLogoLight}`} alt="Vet and Pets" className='site-logo' width={250} />
                            </div>
                            <p class="text-gray-400 mb-6 mt-4 text-justify">
                                {home.footerDescription}
                            </p>
                            <ul className="social-links list-unstyled d-flex gap-2">
                                <li>
                                    <a 
    href="https://www.facebook.com/people/Vet-and-Pets/61578650970508/" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="text-white"
  ><AiFillFacebook size={25} /></a></li>
                                <li><a 
    href="https://www.instagram.com/vet_and_pets25/" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="text-white"
  ><AiFillInstagram size={25} /></a></li>
                                <li><a 
    href="https://www.linkedin.com/in/vet-and-pets/" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="text-white"
  ><AiFillLinkedin size={25}/></a></li>
                            </ul>
                        </Col>
                        <Col>
                            <h5 className="mb-3">Quick Links</h5>
                            <ul className="list-unstyled">
                                <li><Link to="/" className="text-white">Home</Link></li>
                                <li><Link to="/about" className="text-white">About Us</Link></li>
                                <li><Link to="/pethealth" className="text-white">Pet Health</Link></li>
                                <li><Link to="/blog" className="text-white">Blogs</Link></li>                                
                                <li><Link to="/contact" className="text-white">Contact Us</Link></li>
                            </ul>
                        </Col>
                        {/* <Col>
                            <h5 className="mb-3">Directory Categories</h5>
                            <ul className="list-unstyled">
                                
                                {directoryCategory && directoryCategory.map((category) => (
                                    <li key={category.categoryName}>
                                        <Link to={`/${category.categorySlug.toLowerCase()}`} className="text-white">{category.categoryName}</Link>
                                    </li>
                                ))}
                            </ul>

                        </Col> */}
                        <Col>
                            <h5 className="mb-3">Directory Categories</h5>
                            <ul className="list-unstyled">
                                {displayedCategories.map((category) => (
                                    <li key={category.categoryName} className="mb-1">
                                        <Link to={`/${category.categorySlug.toLowerCase()}`} className="text-white">{category.categoryName}</Link>
                                    </li>
                                ))}
                                {directoryCategory.length > 5 && (
                                    <li className="mt-2">
                                        <Link 
                                            to="/directory-categories" 
                                            className="text-info text-decoration-none text-orange footer-view-more"
                                            style={{ fontSize: '0.9rem' }}
                                        >
                                            View More <HiArrowLongRight />
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </Col>
                        <Col>
                            <h5 className="mb-3">Pet Categories</h5>
                            <ul className="list-unstyled">
                                {/* {console.log("Footer categoryPage:", categoryPage)} */}
                                {categoryPage && categoryPage.map((category) => (
                                    <li key={category.category._id}>
                                        <Link to={`/type/${category.category.categoryName.toLowerCase()}`} className="text-white">{category.category.categoryName}</Link>
                                    </li>
                                ))}
                                {/* <li><Link to="/directory?category=dogs" className="text-white">Dogs</Link></li>
                                <li><Link to="/directory?category=cats" className="text-white">Cats</Link></li>
                                <li><Link to="/directory?category=birds" className="text-white">Birds</Link></li>
                                <li><Link to="/directory?category=fish" className="text-white">Fish</Link></li>
                                <li><Link to="/directory?category=small-pets" className="text-white">Small Pets</Link></li>
                                <li><Link to="/directory?category=exotic-pets" className="text-white">Exotic Pets</Link></li> */}
                            </ul>

                        </Col>
                        <Col>
                            <h5 className="mb-3">Contact Us</h5>
                            {/* <p className="d-flex align-items-center gap-3 text-gray-400"> <HiOutlineLocationMarker size={20} className='text-orange flex-shrink-0' /> <span>{home.footerAddress} {home.footerLocation}</span></p> */}
                            <p className="d-flex align-items-center gap-3 text-gray-400"> <HiOutlineMail  size={20} className='text-orange flex-shrink-0' /> <span>{home.footerEmail}</span></p>
                            <p className="d-flex align-items-center gap-3 text-gray-400"> <HiOutlinePhone size={20} className='text-orange flex-shrink-0' /> <span>{home.footerContact}</span></p>
                            <p className="d-flex align-items-center gap-3 text-gray-400"> <HiOutlineClock size={20} className='text-orange flex-shrink-0' /> <span>{home.footerWorkingHours}</span></p>
                        </Col>
                    </Row>
                </div>
                <div className="bottom-footer">
                    <Row className='align-items-center'>
                        <Col>
                            <p className='m-0'>&copy; {new Date().getFullYear()} Vet and Pets. All rights reserved.</p>
                        </Col>
                        <Col>
                            <ul className="list-unstyled d-flex gap-4 mb-0 justify-content-end">
                                <li><Link to="/termsandconditions" className="text-white">Terms and Conditions</Link></li>
                                <li><Link to="/privacypolicy" className="text-white">Privacy Policy</Link></li>
                                <li><Link to="/cookiepolicy" className="text-white">Cookie Policy</Link></li>
                            </ul>
                        </Col>
                    </Row>
                </div>
            </Container>
        </footer>
    </div>
  )
}

export default Footer